"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = void 0;
/**
 * Check if empty object or array
 *
 * @param obj
 * @returns {boolean}
 */
var isEmpty = function isEmpty(obj) {
  return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
exports.isEmpty = isEmpty;